import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { Slot } from 'radix-ui'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useWithAffectedOGsHandler } from '@/entities/optimization-group'
import { useBulkDeletePricingCampaignsMutation } from '@/entities/pricing-campaign'

import { confirm } from '@/shared/components/ui/confirmer'
import { ampli } from '@/shared/lib/ampli'

export const BulkDeletePricingCampaigns = ({
	pricingCampaignsIds,
	onDone,
	children,
}: {
	pricingCampaignsIds: string[]
	onDone?: () => void
	children: React.ReactNode
}) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const bulkDeletePricingCampaignsMutation =
		useBulkDeletePricingCampaignsMutation({
			onSuccess() {
				queryClient.invalidateQueries({
					queryKey: ['pricings-settings'],
				})
				queryClient.invalidateQueries({
					queryKey: ['products-counts-by-pc'],
				})

				queryClient.invalidateQueries({
					queryKey: ['pricing-campaigns'],
				})

				return queryClient.invalidateQueries({
					queryKey: ['pricing-campaigns-overview'],
				})
			},
		})
	const bulkDeletePricingCampaigns = useWithAffectedOGsHandler(
		bulkDeletePricingCampaignsMutation
	)
	const handleDelete = async () => {
		const answer = await confirm({
			title: t('pc_detete_confirm_title'),
			description: t('pc_detete_confirm_subtitle'),
			actionText: t('general_delete'),
			cancelText: t('general_cancel'),
			ActionProps: {
				variant: 'destructive',
			},
		})
		if (answer) {
			ampli.settingsPricingCampaignsBulkDeletePCs()
			toast.promise(
				bulkDeletePricingCampaigns.mutateAsync(pricingCampaignsIds),
				{
					loading: t('deleting.proccess', { defaultValue: 'Deleting...' }),
					success: t('deleting.success', {
						defaultValue: 'Deleted successfully',
					}),
					error: t('deleting.error', { defaultValue: 'Error while deleting' }),
				}
			)
		}
	}

	return <Slot.Root onClick={handleDelete}>{children}</Slot.Root>
}
